import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Button, Grid, Typography, Card, CardHeader, CardContent, IconButton, Badge } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { useSelector } from 'react-redux';
import { genfunction } from 'helpers'

const useStyles = makeStyles(theme => ({
    headerbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    MenuImage: {
        width: 70,
        height: 70,
        maxWidth: 70,
        maxHeight: 70
    },
    badge: {
        fontSize: 22
    },
    badgebox: {
        marginBottom: 20,
        width: "100%",
    }
}));

const SubMenuItem = (props) => {

    const classes = useStyles();
    const { Department, onClickAddProduct, onClickProductInfo } = props;

    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);

    const getProductQuantity = (ProductID) => {
        let products = orderProducts.filter(x => x.ProductID == ProductID);
        let qty = 0;
        products.forEach(p => {
            qty += p.Quantity;
        });
        return qty;
    }

    const SubMenuItem = (product, dep) => {
        return <Grid key={product.ProductID + "_Products"} container spacing={1} item xs={12}>
            <Grid container item spacing={1} xs={12}>
                <Grid container item xs={5}>
                    <Grid item xs={12} style={{ alignSelf: "center" }}>
                        <IconButton onClick={() => { onClickProductInfo(product); }}>
                            <InfoIcon color={"primary"} />
                            {product.ProductImageURL && product.ProductImageURL != "" ?
                                <img
                                    className={classes.MenuImage}
                                    width={'100%'}
                                    height={'100%'}
                                    alt="Logo"
                                    src={product.ProductImageURL && product.ProductImageURL != "" ? genfunction.replaceEscapeCharacters(product.ProductImageURL) : process.env.PUBLIC_URL + "/images/foodorder-placeholder.png"} /> : <div className={classes.MenuImage}></div>}
                        </IconButton>
                    </Grid>
                </Grid>
                <Grid container item xs={7}>
                    <Grid item xs={8} style={{ alignSelf: "center" }}>
                        <Typography variant="h5">{genfunction.replaceEscapeCharacters(product.ProductName)}</Typography>
                        <Typography variant="subtitle1">{genfunction.ccyFormat(genfunction.getOrderProductPrice(product))}</Typography>
                    </Grid>
                    <Grid item xs={4} style={{ alignSelf: "center" }} align="right">
                        <Badge className={classes.badgebox} classes={{ badge: classes.badge }} color="error" badgeContent={getProductQuantity(product.ProductID)} variant="standard" />
                        <Button variant='contained' color='primary'
                            onClick={() => onClickAddProduct(dep, product)}
                        >
                            Add
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <hr></hr>
            </Grid>
        </Grid>;
    }


    return (
        <Grid container spacing={1} key={Department.DepartmentName} item xs={12}>
            <Grid item xs={12}>
                <Card>
                    <CardHeader className={classes.headerbox}
                        title={Department.DepartmentName}
                        titleTypographyProps={{ color: "inherit" }}
                    />
                    <CardContent>
                        {Department.Products.map(product => {
                            return SubMenuItem(product, Department)
                        })}
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};

export default SubMenuItem;